import type { ReactNode } from "react";
import { ProductPage } from "./ProductPage";
import { CheckoutPage } from "./CheckoutPage";
import { WishlistPage } from "./WishlistPage";
import { OrderPage } from "./OrderPage";

export type StoreRoute =
  | { kind: "product"; productSlug: string }
  | { kind: "checkout" }
  | { kind: "wishlist" }
  | { kind: "order"; orderId: string };

export function storeRouteFor(path: string): StoreRoute | null {
  const parts = path.split("/").filter(Boolean);
  const prodIdx = parts.indexOf("products");
  if (prodIdx !== -1 && parts[prodIdx + 1]) {
    return { kind: "product", productSlug: parts[prodIdx + 1] };
  }
  if (parts.includes("checkout")) return { kind: "checkout" };
  if (parts.includes("wishlist")) return { kind: "wishlist" };
  const orderIdx = parts.indexOf("order");
  if (orderIdx !== -1 && parts[orderIdx + 1]) {
    return { kind: "order", orderId: parts[orderIdx + 1] };
  }
  return null;
}

export function renderStoreRoute(route: StoreRoute): ReactNode {
  switch (route.kind) {
    case "product":
      return <ProductPage productSlug={route.productSlug} />;
    case "checkout":
      return <CheckoutPage />;
    case "wishlist":
      return <WishlistPage />;
    case "order":
      return <OrderPage orderId={route.orderId} />;
  }
}
